import { useQuery } from 'react-query';

import { useUser } from '~/features/user/hooks/use-user';
import { useClientRender } from '~/hooks/use-client-render';

import { getUserPurchaseStats } from '../controllers/get-user-purchase-stats';
import { CustomerStatus } from '../models/customer-status';

export function useUserPurchaseStats() {
  const clientReady = useClientRender();
  const { jwt, userId, userIsLoading, isUserAuthenticated } = useUser();

  const { data, isLoading, status } = useQuery(
    ['userPurchaseStats', userId],
    () => getUserPurchaseStats({ jwt: jwt!, userId: userId! }),
    {
      enabled: clientReady && !userIsLoading && isUserAuthenticated,
    }
  );

  const customerStatus: CustomerStatus = data?.has_orders ? 'existing' : 'new';
  const eligibleForTrial = Boolean(data?.eligible_for_trial);

  return {
    data,
    isLoading,
    status,
    customerStatus,
    eligibleForTrial,
  } as const;
}
